// extracted by mini-css-extract-plugin
export var text = "_2k-0";